import React from "react";
import styles from "./Empty.module.scss";

interface EmptyProps {
  icon: React.ReactNode;
  titleText: string;
  subtitleText: string;
  button: React.ReactNode;
}

const Empty: React.FC<EmptyProps> = ({ icon, titleText, subtitleText, button }) => {
  return (
    <div className={styles.wrapper}>
      {icon}
      <h3 className={styles.title}>{titleText}</h3>
      <p className={styles.subtitle}>{subtitleText}</p>
      <div className={styles.btnWrapper}>{button}</div>
    </div>
  );
};

export default Empty;
